import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { combineReducers } from 'redux';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import authReducer from './slice/AuthSlice';
import toolReducer from './slice/ToolSlice';
import cacheReducer from './slice/CacheSlice';
import LanguageReducer from "./slice/languageSlice";
import { initMessageListener } from 'redux-state-sync';
// createStateSyncMiddleware, // all tag synchronous

import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const rootReducer = combineReducers({
  Language: LanguageReducer,
  auth: authReducer,
  tool: toolReducer,
  cache: cacheReducer
});

const persistedReducer = persistReducer(
  {
    key: 'root',
    version: 1,
    storage: storage,
    // dont cache tool
    blacklist: ['tool', 'session'],
  },
  rootReducer
);

const store = configureStore({
  reducer: persistedReducer,
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat([
      // createStateSyncMiddleware({
      //   predicate: (action) => {
      //     return [
      //       'Auth/setLogin'
      //     ].includes(action.type);
      //   },
      // }),
    ]),
});

initMessageListener(store);

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);

export const persistor = persistStore(store);
export { store };
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
